'use client'
import { useMemo } from 'react'
import { useSession } from '@/shared/ui/providers/AuthSessionProvider'
import { useRequiredParams } from '@/hooks/useRequiredParams'
import { useSearchParams } from '@/lib/next-shim'
import { BookingLayout } from './BookingLayout'
import { BookingProvider } from './BookingProvider'
import { BookingSteps } from './BookingSteps'
import { SessionRecoveryNotification } from './SessionRecoveryNotification'
import { getInitialState } from '../model/bookingReducer'
import { BookingSkeleton } from './Skeleton'

export function BookingPage() {
  const { meetingLink } = useRequiredParams(['meetingLink'])
  const { status } = useSession()
  const searchParams = useSearchParams()

  const isImmediate = searchParams.get('immediate') === 'true'
  const isLoggedIn = status === 'authenticated'

  const initialState = useMemo(() => {
    return getInitialState(meetingLink, isLoggedIn, isImmediate)
  }, [isLoggedIn, meetingLink, isImmediate])

  if (!initialState) return <BookingSkeleton />

  return (
    <BookingProvider initialState={initialState}>
      <SessionRecoveryNotification />
      <BookingLayout meetingLink={meetingLink}>
        <BookingSteps />
      </BookingLayout>
    </BookingProvider>
  )
}
